export const getCartSideDrawerItemStyle = () => ({
  display: "flex",
  alignItems: "center",
  gap: "12px",
  marginBottom: "16px",
  justifyContent: "space-between",
  "> img": {
    objectFit: "cover",
    borderRadius: "8px",
    width: "80px",
    height: "80px",
  },
});
